import axiosClient from '../lib/api/axiosClient';
import { FileMetadata } from '../models/Post';
import { extractFileMetadata } from '../utils/apiHelpers';

export const fileService = {
    async uploadFile(file: File): Promise<FileMetadata> {
        try {
            const response = await axiosClient.post('/UploadFile', file, {
                headers: {
                    'Content-Type': file.type,
                    'X-File-Name': file.name
                },
                transformRequest: [(data) => data],
            });

            return extractFileMetadata(response.data);
        } catch (error) {
            console.error('Error uploading file:', error);
            throw error;
        }
    },

    async downloadFile(file: FileMetadata) {
        try {
            console.log('Starting download process');
            
            // Extract blob name from FileUrl
            const blobName = file.FileUrl.split('/emplohomepage-blob/')[1];
            if (!blobName) {
                throw new Error('Could not extract blob name from URL');
            }

            console.log('Downloading blob:', blobName);

            const response = await axiosClient.get(`/DownloadFile`, {
                params: {
                    blobName: blobName
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: file.ContentType });
            const url = window.URL.createObjectURL(blob);
            
            const a = document.createElement('a');
            a.href = url;
            a.download = file.FileName;
            document.body.appendChild(a);
            a.click();
            
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            
            console.log('Download completed successfully');
        } catch (error) {
            console.error('Download failed:', error);
            throw error;
        }
    }
}; 